import { useQuery } from 'react-query'

import type { DeduplicationKind } from '../config'
import { DeduplicationService } from '../services'
import type { SearchQueryParams } from '../types'

export const useDeduplicationRuns = (kind: DeduplicationKind, limit: number, offset: number) =>
  useQuery(
    ['deduplication-runs', kind, limit, offset],
    () => DeduplicationService.getRuns({ limit, offset, objectType: kind }),
    {
      refetchInterval: (data) =>
        data?.results.some((run) => run.status === 'running') ? 30_000 : false,
    }
  )
